export const ATTACH_VIDEO_ELEMENT = 'ATTACH_VIDEO_ELEMENT';
export const ATTACH_FULLSCREEN_ELEMENT = 'ATTACH_FULLSCREEN_ELEMENT';
export const HANDLE_LINKED_MEDIA = 'HANDLE_LINKED_MEDIA';
export const LOAD_VIDEO = 'LOAD_VIDEO';
export const UNLOAD_VIDEO = 'UNLOAD_VIDEO';
export const RESET_VIDEO_STATE = 'RESET_VIDEO_STATE';

export const FETCH_USER_INFO = 'FETCH_USER_INFO';
export const CHECK_LICENSE = 'CHECK_LICENSE';
export const ACTIVATE_LICENSE = 'ACTIVATE_LICENSE';
export const ACTIVATE_LICENSE_OFFLINE = 'ACTIVATE_LICENSE_OFFLINE';
export const DEACTIVATE_LICENSE = 'DEACTIVATE_LICENSE';
export const GENERATE_INSTALLATION_ID = 'GENERATE_INSTALLATION_ID';

export const PLAY_VIDEO = 'PLAY_VIDEO';
export const PAUSE_VIDEO = 'PAUSE_VIDEO';
export const FAST_FORWARD = 'FAST_FORWARD';
export const REWIND = 'REWIND';
export const JUMP_TO_TIME = 'JUMP_TO_TIME';
export const JUMP_BACK_FRAMES = 'JUMP_BACK_FRAMES';
export const JUMP_FORWARD_FRAMES = 'JUMP_FORWARD_FRAMES';
export const JUMP_TO_BEGINNING = 'JUMP_TO_BEGINNING';
export const JUMP_TO_END = 'JUMP_TO_END';
export const JUMP_TO_FRAME = 'JUMP_TO_FRAME';
export const JUMP_TO_PREVIOUS_MARKER = 'JUMP_TO_PREVIOUS_MARKER';
export const JUMP_TO_NEXT_MARKER = 'JUMP_TO_NEXT_MARKER';
export const JUMP_TO_PREVIOUS_IFRAME = 'JUMP_TO_PREVIOUS_IFRAME';
export const JUMP_TO_NEXT_IFRAME = 'JUMP_TO_NEXT_IFRAME';
export const SELECT_TIME_DISPLAY_SOURCE = 'SELECT_TIME_DISPLAY_SOURCE';
export const SELECT_FIRST_TIMECODE_TRACK = 'SELECT_FIRST_TIMECODE_TRACK';
export const TOGGLE_MUTE = 'TOGGLE_MUTE';
export const TOGGLE_REPEAT = 'TOGGLE_REPEAT';
export const CHANGE_PLAYBACK_RATE = 'CHANGE_PLAYBACK_RATE';
export const SPEED_UP = 'SPEED_UP';
export const SLOW_DOWN = 'SLOW_DOWN';
export const ADJUST_VOLUME = 'ADJUST_VOLUME';
export const SELECT_AUDIO_TRACK = 'SELECT_AUDIO_TRACK';
export const SELECT_NEXT_AUDIO_TRACK = 'SELECT_NEXT_AUDIO_TRACK';
export const MODIFY_AUDIO_SOUND_FIELD = 'MODIFY_AUDIO_SOUND_FIELD';
export const ADJUST_VIDEO_QUALITY = 'ADJUST_VIDEO_QUALITY';
export const SELECT_OVERLAYS = 'SELECT_OVERLAYS';
export const SHOW_FULLSCREEN = 'SHOW_FULLSCREEN';
export const EXIT_FULLSCREEN = 'EXIT_FULLSCREEN';
export const MARK_IN = 'MARK_IN';
export const CLEAR_MARK_IN = 'CLEAR_MARK_IN';
export const MARK_OUT = 'MARK_OUT';
export const CLEAR_MARK_OUT = 'CLEAR_MARK_OUT';
export const COPY_MEDIA_PATH = 'COPY_MEDIA_PATH';
export const OBSERVE_INDEXING = 'OBSERVE_INDEXING';
export const END_INDEXING_OBSERVATION = 'END_INDEXING_OBSERVATION';
export const ADVANCE_INDEXING = 'ADVANCE_INDEXING';
export const SIMULATE_ALPHA = 'SIMULATE_ALPHA';

export const ADD_SUBTITLE_SOURCE = 'ADD_SUBTITLE_SOURCE';
export const REMOVE_SUBTITLE_SOURCE = 'REMOVE_SUBTITLE_SOURCE';
export const SELECT_SUBTITLE_SOURCE = 'SELECT_SUBTITLE_SOURCE';
export const SELECT_NEXT_SUBTITLE_SOURCE = 'SELECT_NEXT_SUBTITLE_SOURCE';
export const SELECT_PERSISTED_SUBTITLE_SOURCE = 'SELECT_PERSISTED_SUBTITLE_SOURCE';
export const TURN_OFF_SUBTITLES = 'TURN_OFF_SUBTITLES';

export const FETCH_PLUGIN_SCHEMAS = 'FETCH_SCHEMA_PLUGINS';
export const FETCH_CLIPLIST_PLUGIN_SCHEMAS = 'FETCH_CLIPLIST_PLUGIN_SCHEMAS';
export const UPDATE_PLUGIN_MODEL = 'UPDATE_PLUGIN_MODEL';
export const UPDATE_PLUGIN_SETTINGS = 'UPDATE_PLUGIN_SETTINGS';
export const EXECUTE_PLUGIN = 'EXECUTE_PLUGIN';

export const FETCH_HISTORY = 'FETCH_HISTORY';
export const ADD_TO_HISTORY = 'ADD_TO_HISTORY';

export const ATTACH_QUICKVIEW_ELEMENT = 'ATTACH_QUICKVIEW_ELEMENT';
export const START_QUICKVIEW = 'START_QUICKVIEW';
export const STOP_QUICKVIEW = 'STOP_QUICKVIEW';
export const SELECT_WAVEFORM_MARKS = 'SELECT_WAVEFORM_MARKS';
export const SELECT_ROTATION = 'SELECT ROTATION'

export const START_SCOPES = 'START_SCOPES';
export const STOP_SCOPES = 'STOP_SCOPES';
export const SAVE_SCOPE_IMAGE = 'SAVE_SCOPE_IMAGE';

export const LOG_CLIP = 'LOG_CLIP';
export const REMOVE_CLIP = 'REMOVE_CLIP';
export const CLEAR_CLIPS = 'CLEAR_CLIPS';
export const MOVE_CLIP_UP = 'MOVE_CLIP_UP';
export const MOVE_CLIP_DOWN = 'MOVE_CLIP_DOWN';
export const UPDATE_CLIP = 'UPDATE_CLIP';
export const UPDATE_CLIP_THUMBNAIL = 'UPDATE_CLIP_THUMBNAIL';
export const SELECT_CLIPS_OUTPUT = 'SELECT_CLIPS_OUTPUT';
export const SUBMIT_CLIPS = 'SUBMIT_CLIPS';
export const LOAD_CLIPS = 'LOAD_CLIPS';
export const EXPORT_CLIPS = 'EXPORT_CLIPS';
export const IMPORT_CLIPS = 'IMPORT_CLIPS';
export const COPY_CLIPLIST_PATH = 'COPY_CLIPLIST_PATH';

export const WATCH_FOR_ANNOTATIONS = 'WATCH_FOR_ANNOTATIONS';
export const STOP_WATCHING_FOR_ANNOTATIONS = 'STOP_WATCHING_FOR_ANNOTATIONS';
export const ADD_ANNOTATION = 'ADD_ANNOTATION';
export const UPDATE_ANNOTATION = 'UPDATE_ANNOTATION';
export const REMOVE_ANNOTATION = 'REMOVE_ANNOTATION';
export const CLEAR_ANNOTATIONS = 'CLEAR_ANNOTATIONS';
export const ADD_SHAPE_TO_ANNOTATION = 'ADD_SHAPE_TO_ANNOTATION';
export const UPDATE_SHAPES_ON_ANNOTATION = 'UPDATE_SHAPE_ON_ANNOTATION';
export const REMOVE_SHAPES_FROM_ANNOTATION = 'REMOVE_SHAPE_FROM_ANNOTATION';
export const ADD_REPLY_TO_ANNOTATION = 'ADD_REPLAY_TO_ANNOTATION';
export const UPDATE_ANNOTATION_REPLY = 'UPDATE_ANNOTATION_REPLY';
export const REMOVE_ANNOTATION_REPLY = 'REMOVE_ANNOTATION_REPLY';
export const IMPORT_ANNOTATIONS = 'IMPORT_ANNOTATIONS';
export const EXPORT_ANNOTATIONS = 'EXPORT_ANNOTATIONS';
export const SCROLL_TO_ANNOTATION = 'SCROLL_TO_ANNOTATION';

export const RESIZE_MEDIA_COLUMN = 'RESIZE_MEDIA_COLUMN';
export const RESIZE_INFO_COLUMN = 'RESIZE_INFO_COLUMN';
export const RESIZE_COLUMNS = 'RESIZE_COLUMNS';
export const RESTORE_LAYOUT = 'RESTORE_LAYOUT';
export const SELECT_TOP_VISIBLE_TABS = 'SELECT_TOP_VISIBLE_TABS';
export const SELECT_BOTTOM_VISIBLE_TABS = 'SELECT_BOTTOM_VISIBLE_TABS';
export const RESET_TABS = 'RESET_TABS';
export const ZOOM_ON_WAVEFORM = 'ZOOM_ON_WAVEFORM';

export const LIST_FILES = 'LIST_FILES';
export const ORDER_FILES = 'ORDER_FILES';
export const FILTER_FILES = 'FILTER_FILES';
export const FAVORITE_FOLDER = 'FAVORITE_FOLDER';
export const UNFAVORITE_FOLDER = 'UNFAVORITE_FOLDER';